<!-- Grid View -->
<!-- <p-toast></p-toast> -->
<div class="gridView">
  @for (item of currResultData; track $index) {
  <div class="gridView_card">
    <div class="gridView_card_heading">
      #{{ item.S_NO }}. {{ item.activeIngredientNative }}
    </div>
    <div class="row gridView_card_body">
      <div class="col col-12 col-lg-2 order-1">
        <div class="row">
          <!-- country card -->
          <div
            class="col-6 col-lg-12 mb-lg-4 countryImageContainer"
            *ngIf="item.country && this.isShowField('country')"
          >
            <div class="countryImageContainer_countryImageBox">
              <img
                [src]="
                  'https://www.chemrobotics.com/agropat/images/flag/' +
                  item.country +
                  '.png'
                "
              />
            </div>
          </div>

          <!-- productPackageImage (Company) card -->
          <div
            class="col-6 col-lg-12 companyImageContainer"
            *ngIf="this.isShowField('productPackageImage')"
          >
            <div class="companyImageContainer_companyImageBox">
              <img
                [src]="
                  item.productPackageImage
                    ? 'https://www.chemrobotics.com/agropat/images/agro_pro_dir/product_image1/' +
                      item.productPackageImage
                    : 'https://www.chemrobotics.com/assets/images/GAPD-Default-Image.png'
                "
                alt="Company"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col col-12 col-lg-7 order-3 order-lg-2">
        <div class="row">
          <!-- gbrn card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="item.gbrn && this.isShowField('gbrn')"
          >
            <p class="field">
              <span>{{ getFieldDisplayName("gbrn") }}</span
              ><i class="pi pi-copy" (click)="copyToClipboard(item.gbrn)"></i>
            </p>
            <p class="value">
              {{
                item.gbrn.length < 290
                  ? item.gbrn
                  : (item.gbrn | slice : 0 : 290) + "..."
              }}
              <button
                *ngIf="item.gbrn.length > 290"
                class="readMoreBtn"
                (click)="showAllGapdTableData(item, 'gbrn')"
              >
                Read More
              </button>
            </p>
          </div>

          <!-- cbrnGapd card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="item.cbrnGapd && this.isShowField('cbrnGapd')"
          >
            <p class="field">
              <span>{{ getFieldDisplayName("cbrnGapd") }} </span
              ><i
                class="pi pi-copy"
                (click)="copyToClipboard(item.cbrnGapd)"
              ></i>
            </p>
            <p class="value">
              {{
                item.cbrnGapd.length < 290
                  ? item.cbrnGapd
                  : (item.cbrnGapd | slice : 0 : 290) + "..."
              }}
              <button
                *ngIf="item.cbrnGapd.length > 290"
                class="readMoreBtn"
                (click)="showAllGapdTableData(item, 'cbrnGapd')"
              >
                Read More
              </button>
            </p>
          </div>

          <!-- casRn card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="
              getGbrnProductLength(item, 'casRn') > 0 &&
              this.isShowField('casRn')
            "
          >
            <p class="field">
              <span>{{ getFieldDisplayName("casRn") }}</span
              ><i
                class="pi pi-copy"
                (click)="copyToClipboard(getAllGapdProductData(item, 'casRn'))"
              ></i>
            </p>
            <p class="value">
              {{ getGbrnProductString(item, "casRn") }}
              <button
                *ngIf="getGbrnProductLength(item, 'casRn') > 290"
                class="readMoreBtn"
                (click)="showAllGapdProductData(item, 'casRn')"
              >
                Read More
              </button>
            </p>
          </div>

          <!-- iupac card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="
              getGbrnProductLength(item, 'iupac') > 0 &&
              this.isShowField('iupac')
            "
          >
            <p class="field">
              <span>{{ getFieldDisplayName("iupac") }} </span
              ><i
                class="pi pi-copy"
                (click)="copyToClipboard(getAllGapdProductData(item, 'iupac'))"
              ></i>
            </p>
            <p class="value">
              {{ getGbrnProductString(item, "iupac") }}
              <button
                *ngIf="getGbrnProductLength(item, 'iupac') > 290"
                class="readMoreBtn"
                (click)="showAllGapdProductData(item, 'iupac')"
              >
                Read More
              </button>
            </p>
          </div>

          <!-- trade_proprietary_names card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="
              item.trade_proprietary_names &&
              this.isShowField('trade_proprietary_names')
            "
          >
            <p class="field">
              <span>
                {{ getFieldDisplayName("trade_proprietary_names") }}
              </span>
              <i
                class="pi pi-copy"
                (click)="copyToClipboard(item.trade_proprietary_names)"
              ></i>
            </p>
            <p class="value">
              {{
                item.trade_proprietary_names.length < 290
                  ? item.trade_proprietary_names
                  : (item.trade_proprietary_names | slice : 0 : 290) + "..."
              }}
              <button
                *ngIf="item.trade_proprietary_names.length > 290"
                class="readMoreBtn"
                (click)="showAllData(item.trade_proprietary_names)"
              >
                Read More
              </button>
            </p>
          </div>

          <!-- chemicalClass card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="
              getGbrnProductLength(item, 'chemicalClass') > 0 &&
              this.isShowField('chemicalClass')
            "
          >
            <p class="field">
              <span> {{ getFieldDisplayName("chemicalClass") }}</span>
              <i
                class="pi pi-copy"
                (click)="
                  copyToClipboard(getAllGapdProductData(item, 'chemicalClass'))
                "
              ></i>
            </p>
            <p class="value">
              {{ getGbrnProductString(item, "chemicalClass") }}
              <button
                *ngIf="getGbrnProductLength(item, 'chemicalClass') > 290"
                class="readMoreBtn"
                (click)="showAllGapdProductData(item, 'chemicalClass')"
              >
                Read More
              </button>
            </p>
          </div>

          <!-- formulation card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="item.formulation && this.isShowField('formulation')"
          >
            <p class="field">
              <span> {{ getFieldDisplayName("formulation") }}</span>
              <i
                class="pi pi-copy"
                (click)="copyToClipboard(item.formulation)"
              ></i>
            </p>
            <p class="value">
              {{
                item.formulation.length < 290
                  ? item.formulation
                  : (item.formulation | slice : 0 : 290) + "..."
              }}
              <button
                *ngIf="item.formulation.length > 290"
                class="readMoreBtn"
                (click)="showAllGapdTableData(item, 'formulation')"
              >
                Read More
              </button>
            </p>
          </div>

          <!-- mechanismOfActionMoa card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="
              getGbrnProductLength(item, 'mechanismOfActionMoa') > 0 &&
              this.isShowField('mechanismOfActionMoa')
            "
          >
            <p class="field">
              <span> {{ getFieldDisplayName("mechanismOfActionMoa") }}</span>
              <i
                class="pi pi-copy"
                (click)="
                  copyToClipboard(
                    getAllGapdProductData(item, 'mechanismOfActionMoa')
                  )
                "
              ></i>
            </p>
            <p class="value">
              {{ getGbrnProductString(item, "mechanismOfActionMoa") }}
              <button
                *ngIf="getGbrnProductLength(item, 'mechanismOfActionMoa') > 290"
                class="readMoreBtn"
                (click)="showAllGapdProductData(item, 'mechanismOfActionMoa')"
              >
                Read More
              </button>
            </p>
          </div>

          <!-- indication card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="
              getGbrnProductLength(item, 'indication') > 0 &&
              this.isShowField('indication')
            "
          >
            <p class="field">
              <span> {{ getFieldDisplayName("indication") }} </span>
              <i
                class="pi pi-copy"
                (click)="
                  copyToClipboard(getAllGapdProductData(item, 'indication'))
                "
              ></i>
            </p>
            <p class="value">
              {{ getGbrnProductString(item, "indication") }}
              <button
                *ngIf="getGbrnProductLength(item, 'indication') > 290"
                class="readMoreBtn"
                (click)="showAllGapdProductData(item, 'indication')"
              >
                Read More
              </button>
            </p>
          </div>

          <!-- company card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="item.company && this.isShowField('company')"
          >
            <p class="field">
              <span> {{ getFieldDisplayName("company") }}</span>
              <i class="pi pi-copy" (click)="copyToClipboard(item.company)"></i>
            </p>
            <p class="value">
              {{
                item.company.length < 290
                  ? item.company
                  : (item.company | slice : 0 : 290) + "..."
              }}
              <button
                *ngIf="item.company.length > 290"
                class="readMoreBtn"
                (click)="showAllGapdTableData(item, 'company')"
              >
                Read More
              </button>
            </p>
          </div>

          <!-- applicantRegistrationHolder card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="
              item.applicantRegistrationHolder.length > 0 &&
              this.isShowField('applicantRegistrationHolder')
            "
          >
            <p class="field">
              <span>
                {{ getFieldDisplayName("applicantRegistrationHolder") }}</span
              >
              <i
                class="pi pi-copy"
                (click)="copyToClipboard(item.applicantRegistrationHolder)"
              ></i>
            </p>
            <p class="value" *ngIf="item.applicantRegistrationHolder">
              {{
                item.applicantRegistrationHolder.length < 290
                  ? item.applicantRegistrationHolder
                  : (item.applicantRegistrationHolder | slice : 0 : 290) + "..."
              }}
              <button
                *ngIf="item.applicantRegistrationHolder.length > 290"
                class="readMoreBtn"
                (click)="
                  showAllGapdTableData(item, 'applicantRegistrationHolder')
                "
              >
                Read More
              </button>
            </p>
          </div>

          <!-- use card -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="item.use && this.isShowField('use')"
          >
            <p class="field">
              <span> {{ getFieldDisplayName("use") }}</span>
              <i class="pi pi-copy" (click)="copyToClipboard(item.use)"></i>
            </p>
            <p class="value">
              {{
                item.use.length < 290
                  ? item.use
                  : (item.use | slice : 0 : 290) + "..."
              }}
              <button
                *ngIf="item.use.length > 290"
                class="readMoreBtn"
                (click)="showAllGapdTableData(item, 'use')"
              >
                Read More
              </button>
            </p>
          </div>

          <!-- document -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="item.documents && this.isShowField('documents')"
          >
            <p class="field">
              <span> {{ getFieldDisplayName("documents") }}</span>
              <i
                class="pi pi-copy"
                (click)="copyToClipboard(item.documents)"
              ></i>
            </p>
            <p class="value">
              <ng-container
                *ngFor="
                  let doc of getDocumentLinks(item.documents);
                  let i = index
                "
              >
                <a
                  [href]="
                    'https://www.chemrobotics.com/agropat/pdf/gsda/docs/' + doc
                  "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ doc.length < 290 ? doc : (doc | slice : 0 : 290) + "..." }}
                </a>
                <span *ngIf="i !== getDocumentLinks(item.documents).length - 1">
                  |
                </span>
              </ng-container>
              <button
                *ngIf="item.documents.length > 290"
                class="readMoreBtn"
                (click)="showAllGapdTableData(item, 'documents')"
              >
                Read More
              </button>
            </p>
          </div>
          <!-- factsheet -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="item.factsheet && this.isShowField('factsheet')"
          >
            <p class="field">
              <span> {{ getFieldDisplayName("factsheet") }}</span>
              <i
                class="pi pi-copy"
                (click)="copyToClipboard(item.factsheet)"
              ></i>
            </p>
            <p class="value">
              <ng-container
                *ngFor="
                  let doc of getDocumentLinks(item.factsheet);
                  let i = index
                "
              >
                <a
                  [href]="
                    'https://www.chemrobotics.com/agropat/pdf/gsda/docs/' + doc
                  "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ doc.length < 290 ? doc : (doc | slice : 0 : 290) + "..." }}
                </a>
                <span *ngIf="i !== getDocumentLinks(item.factsheet).length - 1">
                  |
                </span>
              </ng-container>
              <button
                *ngIf="item.factsheet.length > 290"
                class="readMoreBtn"
                (click)="showAllGapdTableData(item, 'factsheet')"
              >
                Read More
              </button>
            </p>
          </div>
          <!-- monograph -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="item.monograph && this.isShowField('monograph')"
          >
            <p class="field">
              <span> {{ getFieldDisplayName("monograph") }}</span>
              <i
                class="pi pi-copy"
                (click)="copyToClipboard(item.monograph)"
              ></i>
            </p>
            <p class="value">
              <ng-container
                *ngFor="
                  let doc of getDocumentLinks(item.monograph);
                  let i = index
                "
              >
                <a
                  [href]="
                    'https://www.chemrobotics.com/agropat/pdf/gsda/docs/' + doc
                  "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ doc.length < 290 ? doc : (doc | slice : 0 : 290) + "..." }}
                </a>
                <span *ngIf="i !== getDocumentLinks(item.monograph).length - 1">
                  |
                </span>
              </ng-container>
              <button
                *ngIf="item.monograph.length > 290"
                class="readMoreBtn"
                (click)="showAllGapdTableData(item, 'monograph')"
              >
                Read More
              </button>
            </p>
          </div>
          <!-- productArchive -->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="item.productArchive && this.isShowField('productArchive')"
          >
            <p class="field">
              <span> {{ getFieldDisplayName("productArchive") }}</span>
              <i
                class="pi pi-copy"
                (click)="copyToClipboard(item.productArchive)"
              ></i>
            </p>
            <p class="value">
              <ng-container
                *ngFor="
                  let doc of getDocumentLinks(item.productArchive);
                  let i = index
                "
              >
                <a
                  [href]="
                    'https://www.chemrobotics.com/agropat/pdf/gsda/docs/' + doc
                  "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ doc.length < 290 ? doc : (doc | slice : 0 : 290) + "..." }}
                </a>
                <span
                  *ngIf="
                    i !== getDocumentLinks(item.productArchive).length - 1
                  "
                >
                  |
                </span>
              </ng-container>
              <button
                *ngIf="item.productArchive.length > 290"
                class="readMoreBtn"
                (click)="showAllGapdTableData(item, 'productArchive')"
              >
                Read More
              </button>
            </p>
          </div>
          <!-- mutipleDocuments-->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="
              item.mutipleDocuments && this.isShowField('mutipleDocuments')
            "
          >
            <p class="field">
              <span> {{ getFieldDisplayName("mutipleDocuments") }}</span>
              <i
                class="pi pi-copy"
                (click)="copyToClipboard(item.mutipleDocuments)"
              ></i>
            </p>
            <p class="value">
              <ng-container
                *ngFor="
                  let doc of getDocumentLinks(item.mutipleDocuments);
                  let i = index
                "
              >
                <a
                  [href]="
                    'https://www.chemrobotics.com/agropat/pdf/gsda/docs/' + doc
                  "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ doc.length < 290 ? doc : (doc | slice : 0 : 290) + "..." }}
                </a>
                <span
                  *ngIf="
                    i !== getDocumentLinks(item.mutipleDocuments).length - 1
                  "
                >
                  |
                </span>
              </ng-container>
              <button
                *ngIf="item.mutipleDocuments.length > 290"
                class="readMoreBtn"
                (click)="showAllGapdTableData(item, 'mutipleDocuments')"
              >
                Read More
              </button>
            </p>
          </div>
          <!-- regulatoryDocuments-->
          <div
            class="col-12 col-sm-6 py-2"
            *ngIf="
              item.regulatoryDocuments &&
              this.isShowField('regulatoryDocuments')
            "
          >
            <p class="field">
              <span> {{ getFieldDisplayName("regulatoryDocuments") }}</span>
              <i
                class="pi pi-copy"
                (click)="copyToClipboard(item.regulatoryDocuments)"
              ></i>
            </p>
            <p class="value">
              <ng-container
                *ngFor="
                  let doc of getDocumentLinks(item.regulatoryDocuments);
                  let i = index
                "
              >
                <a [href]="doc" target="_blank" rel="noopener noreferrer">
                  {{ doc.length < 290 ? doc : (doc | slice : 0 : 290) + "..." }}
                </a>
                <span
                  *ngIf="
                    i !== getDocumentLinks(item.regulatoryDocuments).length - 1
                  "
                >
                  |
                </span>
              </ng-container>

              <button
                *ngIf="item.regulatoryDocuments.length > 290"
                class="readMoreBtn"
                (click)="showAllGapdTableData(item, 'regulatoryDocuments')"
              >
                Read More
              </button>
            </p>
          </div>
        </div>
      </div>
      <div class="col col-12 col-lg-3 order-2 order-lg-3">
        <!-- chemicalStructure card -->
        <div
          class="chemicalStructureContainer"
          *ngIf="
            item.gbrn_products.length > 0 &&
            this.isShowField('chemicalStructure')
          "
        >
          @for (garnProduct_item of item.gbrn_products; track $index) {
          <div class="chemicalStructureContainer_imageBox">
            <img
              [src]="
                'https://www.chemrobotics.com/agropat/images/chemical_structure/' +
                garnProduct_item?.chemicalStructure
              "
              alt="Chemical Structure"
            />
            <app-button1
              class="chemicalStructureContainer_imageBox_viewBtn"
              buttonText="View"
              (click)="
                showImage(
                  'https://www.chemrobotics.com/agropat/images/chemical_structure/' +
                    garnProduct_item?.chemicalStructure
                )
              "
            ></app-button1>
          </div>
          }
        </div>
      </div>
    </div>
    <app-button2
      class="gridView_card_moreInfoBtn"
      buttonText="More Info"
      (click)="openDetailPage(item)"
    ></app-button2>
  </div>
  }

  <p-paginator
    (onPageChange)="onPageChange($event)"
    [first]="first"
    [rows]="rows"
    [totalRecords]="currResultTotal"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[15, 30, 50]"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
  ></p-paginator>
</div>

<!-- Chemical Structure full view dialog -->
<p-dialog
  header="Chemical Structure"
  [(visible)]="display"
  [modal]="true"
  [style]="{ width: 'auto' }"
>
  <div style="display: flex; justify-content: center; align-items: center">
    <img
      [src]="images[0]?.itemImageSrc"
      alt=""
      style="object-fit: contain; max-height: 70vh"
    />
  </div>
</p-dialog>

<!-- Show complete data dialog -->
<p-dialog
  header="Complete Data"
  [(visible)]="isShowReadMoreDetailDialog"
  [modal]="true"
  [style]="{ width: '50vw' }"
>
  <ul>
    <li *ngFor="let data of currReadMoreData">
      {{ data }}
    </li>
  </ul>
  <div *ngIf="currReadMoreData?.length === 0">No data available.</div>
</p-dialog>
